/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import T from '@prisjakt/ui-translate';
import Button from '@prisjakt/ui-button';

import Modal from '../../../../components/modal';
import Deals from '../deals';
import CampaignLink from '../link';
import actions from '../../../store/actions';

import './index.scss';

const styles = bemGenerator('store-campaign-items-popup', ['header', 'footer']);

const CampaignStorePopup = ({
  router,
  shop,
  onRequestClose,
  campaign,
  dealCount,
  storeLinkClick,
}) => (
  <Modal isOpen shouldShowCloseIcon onRequestClose={onRequestClose}>
    <div className={styles.block}>
      {shop.featured ? (
        <a
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          rel="nofollow noopener"
          className={styles.header}
          onClick={() => {
            storeLinkClick(shop);
          }}
          href={shop.external_uri}
        >
          <img
            width={176}
            alt={shop.name}
            src={shop.logo && (shop.logo['176'] || shop.logo['96'])}
          />
          {shop.name}
          {' - '}
          <T domain="search">raw-search.go-to-shop</T>
        </a>
      ) : (
        <h3 className={styles.header}>{shop.name}</h3>
      )}

      <Deals
        campaignId={campaign.id}
        campaignName={campaign.name}
        router={router}
        rangeOptions={[]}
        size={dealCount}
        stores={[shop.id]}
        onChange={() => {}}
        onCampaignItemClick={() => {}}
      />

      <div className={styles.footer}>
        <CampaignLink
          campaign={campaign}
          queryString={`?stores=${shop.id}`}
          linkContent={
            <Button color="primary" variant="outlined">
              <T domain="campaigns">link.view-all</T>
            </Button>
          }
        />
      </div>
    </div>
  </Modal>
);

const { shape, func, string, number, bool } = PropTypes;

CampaignStorePopup.propTypes = {
  router: shape({
    id: number,
  }).isRequired,
  campaign: shape({
    id: number,
    name: string,
    type: string,
    state: string,
    slug: string,
    web_uri: shape({
      mobile: string,
      desktop: string,
      responsive: string,
    }),
  }),
  onRequestClose: func,
  storeLinkClick: func,
  shop: shape({
    id: number,
    name: string,
    featured: bool,
    external_uri: string,
    logo: shape({
      96: string,
      176: string,
    }),
  }).isRequired,
  dealCount: number,
};

CampaignStorePopup.defaultProps = {
  onRequestClose: () => {},
  storeLinkClick: () => {},
  campaign: undefined,
  dealCount: 8,
};

export default connect(
  state => state,
  actions
)(CampaignStorePopup);
